import { useGetPastConferencesApi } from '@/api/conference';
import * as S from './style';
import useIsMobile from '@/hooks/useIsMobile';
import TablePagination from '@/components/common/Pagination/TablePagination';
import BoardTable from '@/components/common/Table/BoardTable/BoardTable';
import { useState } from 'react';
import ConferenceList from '../ConferenceList/ConferenceList';
import { generateColumns } from '@/constants/table';
import { convertInfoValue } from '@/utils/convertValue';
import { useLocation, useNavigate } from 'react-router-dom';
import { SyncLoader } from 'react-spinners';

const BeforeConference = () => {
	const isMobile = useIsMobile(900);
	const navigate = useNavigate();
	const location = useLocation();
	const [page, setPage] = useState(1);
	const params = location.state?.menu ?? '학술대회 안내';

	const { data: pastConferencesData } = useGetPastConferencesApi({
		page: page,
		row: 10,
	});
	const handleGetPk = (pk: number | string) => {
		navigate(`/conference/detail/${pk}`, { state: { menu: params } });
	};
	return (
		<S.ConferenceContainer>
			<S.ConferenceBoardBox>
				{!isMobile ? (
					<TablePagination activePage={page} totalItems={pastConferencesData?.total_count ?? 0} onChange={(page) => setPage(page)}>
						<BoardTable
							columns={generateColumns(pastConferencesData?.conferences ?? [])}
							page={page}
							data={pastConferencesData?.conferences ?? []}
							totalItems={pastConferencesData?.total_count ?? 0}
							onClick={handleGetPk}
						/>
					</TablePagination>
				) : (
					<TablePagination activePage={page} totalItems={pastConferencesData?.total_count ?? 0} onChange={(page) => setPage(page)}>
						<ConferenceList data={pastConferencesData?.conferences ?? []} sort="guide" />
					</TablePagination>
				)}
			</S.ConferenceBoardBox>
		</S.ConferenceContainer>
	);
};

export default BeforeConference;
